import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IApplicationWithRoles, IUserRole } from 'app/users/detail/user-details-roles.component';

@Component({
  selector: 'app-user-details-roles-application',
  templateUrl: './user-details-roles-application.component.html',
})
export class UserDetailsRolesApplicationComponent {
  @Input()
  application: IApplicationWithRoles;
  @Input()
  readOnly = true;
  @Output()
  toggle = new EventEmitter<IUserRole>();

  onValueChange(value: IUserRole): void {
    this.toggle.emit(value);
  }
}
